import React, { useEffect, useState, useRef } from 'react'
import { useQuery } from 'react-query'
import { useDebouncedCallback } from 'use-debounce'
import { getResourceList } from '../../models/BaseModel'
import { ImageReplacementAnchor, InlineNavigation, Loading, LogoNavigation, DrawerNavigation, BlankErrorBoundry } from '@scrippsproduct/scripps-external-component-library'

import './../../scss/Header.scss'

export default function Header() {
    const [menuLinks, setMenuLinks] = useState([])
    const [logoItems, setLogoItems] = useState([])
    const {isLoading, isSuccess, isError, data} = useQuery(['header', {resourceName: 'header'}], getResourceList)
    const mobileNavRef = useRef()

    useEffect(() => {
        if (isSuccess) {
            setMenuLinks(data.get('menuLinks'))
            setLogoItems(data.get('logoItems'))
        }
    }, [isError, isSuccess, data])

    const handleScroll = useDebouncedCallback(() => {
        if (window.scrollY > 10) {
            mobileNavRef.current.classList.add('mobile-nav--shadow');
        } else {
            mobileNavRef.current.classList.remove('mobile-nav--shadow');
        }
        }, 300) 

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);
    
    return (
        <header>
            <content-constrainer>
                <ImageReplacementAnchor href={`/`} 
                    image={{
                        url: 'https://ewscripps-brightspot-lower.s3.amazonaws.com/b5/63/73d728894ffe9c98564d5db1019d/ion-herologo-white.png', 
                        width: 80, 
                        height: 51,
                    }} 
                    height={3.5}
                    baselineAdjustment={0}
                />
                { (isLoading) && <Loading />}
                <header-menu-wrapper 
                    className="not-sure-yet" 
                    style={{
                        display: 'flex', 
                        justifyContent: 'flex-end'
                    }}
                >
                    { (isSuccess && menuLinks.length > 0) && 
                        <BlankErrorBoundry>
                            <InlineNavigation 
                                links={menuLinks} 
                                classname="main-navigation" 
                                position='right'
                            />
                        </BlankErrorBoundry>
                    } 
                    { (isSuccess && logoItems.length > 0) && 
                        <LogoNavigation 
                            items={logoItems}
                        />
                    }
                </header-menu-wrapper>
            </content-constrainer>
            <nav className="mobile-nav" ref={mobileNavRef}>
                <BlankErrorBoundry>
                    { (isSuccess && menuLinks.length > 0 && logoItems.length > 0) && 
                        <DrawerNavigation
                            links={[
                                {
                                    type: 'internal-link',
                                    href: '/',
                                    label: 'Home',
                                },
                                ...menuLinks]} 
                            items={logoItems}
                            logo={{
                                image: {
                                    url: 'https://ewscripps-brightspot-lower.s3.amazonaws.com/b5/63/73d728894ffe9c98564d5db1019d/ion-herologo-white.png', 
                                    width: 80, 
                                    height: 51,
                                },
                                href: process.env.REACT_APP_BASE_URL,
                                height: 2.5,
                                baselineAdjustment: 0
                            }}
                            classname="main-navigation"
                            clipPathStart="polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)"
                            clipPathEnd="polygon(0% 0%, 100% 0%, 100% 85%, 0% 100%)"
                            overlayAppendEl={document.querySelector('site-wrapper')}
                        /> 
                    }
                </BlankErrorBoundry>
            </nav>
        </header>
    )
}
